/* unplugin-vue-components disabled */import script from "./esign.vue?vue&type=script&lang=ts&setup=true"
export * from "./esign.vue?vue&type=script&lang=ts&setup=true"

import "./esign.vue?vue&type=style&index=0&id=e9eb849c&lang=less&scoped=true"

import exportComponent from "/data/liulv-h5/quantum-technology/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9eb849c"]])

export default __exports__